import Vue from 'vue';
import OfsCrud from '@oneflow/ofs-vuex-crud';
import httpProviderInstance from './httpProviderInstance';
import registerAuthModule from './auth';
import registerLangStoreModule from './lang';
import registerNotificationStoreModule from './version-notification';

const setupModules = (store, i18n) => {
	Vue.use(OfsCrud, { store });
	Vue.$ofsCrud.registerTransport({ name: 'http', fn: () => httpProviderInstance });
	registerLangStoreModule(store, i18n);
	registerAuthModule();
	registerNotificationStoreModule(store);
};

export default setupModules;
